
import { Vue, Component, Prop } from "vue-property-decorator";
import MANAGEMENT_VISITS from "@/apollo/projectActivities/GetVisitsCounts.gql";
import MANAGER_VISITS from "@/apollo/projectActivities/GetVisitsCountsManager.gql";
import ProjectModal from "@/components/companyProjects/ProjectModalNew.vue";
import TabsWithRoutes from "@/components/common/TabsWithRoutesV2.vue";
import TabNotificationBubble from "@/components/common/TabNotificationBubbleV2.vue";
import { Company, User } from "@/generated/graphql";
import Roles from "@/entities/Roles";
import RouteTabs from "@/entities/RouteTabs";
import RouteNames from "@/entities/RouteNames";

interface VisitsData {
  draftedCount: {
    aggregate: {
      count: number;
    };
  };
  declinedCount: {
    aggregate: {
      count: number;
    };
  };
  assignedCount: {
    aggregate: {
      count: number;
    };
  };
  offeredCount: {
    aggregate: {
      count: number;
    };
  };
  emptyCount:{
    aggregate: {
      count: number;
    };
  };
  activeCount: {
    aggregate: {
      count: number;
    };
  };
}

@Component({
  components: {
    TabsWithRoutes,
    TabNotificationBubble,
    ProjectModal,
  },
  apollo: {
    visits: {
      query() {
        return this.isManager ? MANAGER_VISITS : MANAGEMENT_VISITS;
      },
      variables() {
        return this.visitsFilter;
      },
      update(data) {
        this.visits = data;
        return data;
      },
    },
  },
})
export default class AllEmptyVisits extends Vue {
  @Prop({ type: Object, required: true }) readonly company!: Company;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  routes = RouteNames;
  containerClasses: string = "h-full";
  visits: VisitsData | null = null;
  dialog: boolean = false;

  get allEmptyTotal(): number {
    if (!this.visits) return 0;
    return (
      this.visits.draftedCount.aggregate.count +
      this.visits.declinedCount.aggregate.count +
      this.visits.offeredCount.aggregate.count + 
      this.visits.emptyCount.aggregate.count
    );
  }

   get visitsFilter() {
    if (this.isManager) {
      return {
        managerId: this.currentUserManagerId,
      };
    }
    return {
      companyId: this.company.id
    }; 
  }

  get currentUserManagerId(): string {
    return this.currentUser.manager!.id;
  }

  get offeredTotal(): number {
    if (!this.visits || !this.visits.offeredCount) return 0;
    return this.visits.offeredCount.aggregate.count;
  }
  get assignedTotal(): number {
    if (!this.visits || !this.visits.activeCount) return 0;
    return this.visits.activeCount.aggregate.count;
  }
  get draftTotal(): number {
    if (!this.visits || !this.visits.draftedCount) return 0;
    return this.visits.draftedCount.aggregate.count;
  }

  get isManager(): boolean {
    return this.currentUser.role === "MANAGER";
  }

  get declinedTotal(): number {
    if (!this.visits || !this.visits.declinedCount) return 0;
    return this.visits.declinedCount.aggregate.count;
  }

  get isAdmin(): boolean {
    return this.currentUser.role === Roles.ADMIN;
  }

  get routeTabs(): RouteTabs {
    return {
      [RouteNames.ALL_EMPTY_VISITS_TAB]: `All Open visits`,
      [RouteNames.PENDING_VISITS]: `Offered`,
      [RouteNames.REJECTED_VISITS]: `Declined`,
      [RouteNames.ALL_DRAFT_VISITS]: `Draft`,
    };
  }

  toggle(): void {
    this.dialog = true;
  }
}
